import { Component } from '@angular/core';

@Component({
  templateUrl: './job-page.component.html',
})
export class JobPageComponent {}
